import { render, staticRenderFns } from "./CommunicationLogFormAdd.vue?vue&type=template&id=334f90ae&scoped=true&"
import script from "./CommunicationLogFormAdd.vue?vue&type=script&lang=js&"
export * from "./CommunicationLogFormAdd.vue?vue&type=script&lang=js&"
import style0 from "./CommunicationLogFormAdd.vue?vue&type=style&index=0&id=334f90ae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "334f90ae",
  null
  
)

export default component.exports